import React, { Fragment } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from 'reactstrap';
import { RadioGroup, Radio } from 'react-radio-group';
import LightboxContainer from '../../../Lightbox';
import config from '../../../../config';

const DIFFICULTY_LEVELS = ['Easy', 'Moderate', 'Hard'];

export function CustomModal({
  modal,
  modalMsg,
  toggle,
  handleSave,
  modalType,
  closeAndToggle,
}) {
  const renderButtons = {
    emptyData: (
      <Fragment key="empty_data_modal_footer">
        <Button color="primary" onClick={handleSave}>
          Yes
        </Button>
        <Button color="secondary" onClick={closeAndToggle}>
          No
        </Button>
      </Fragment>
    ),
    notEmptyData: (
      <Fragment key="not_empty_data_modal_footer">
        <Button color="primary" onClick={handleSave}>
          Save
        </Button>
        <Button color="secondary" onClick={closeAndToggle}>
          Cancel
        </Button>
      </Fragment>
    ),
  };
  return modal ? (
    <Modal isOpen={modal} toggle={closeAndToggle}>
      <ModalHeader toggle={closeAndToggle} />
      <ModalBody>{modalMsg}</ModalBody>
      <ModalFooter>{renderButtons[modalType]}</ModalFooter>
    </Modal>
  ) : null;
}

function simpleInput({ onSimpleIpChange, simpleIpValue, fieldKey, placeholder }) {
  return (
    <input
      className="label-val"
      value={simpleIpValue ? simpleIpValue : ''}
      onChange={onSimpleIpChange}
      name={fieldKey}
      placeholder={placeholder}
    />
  );
}

function selectInput({ onSimpleIpChange, simpleIpValue, fieldKey }) {
  return (
    <Input type="select" name={fieldKey} value={simpleIpValue} onChange={onSimpleIpChange}>
      <option selected={simpleIpValue === ''}>Select One</option>
      {DIFFICULTY_LEVELS.map(level => (
        <option key={level} selected={simpleIpValue === level}>
          {level}
        </option>
      ))}
    </Input>
  );
}

function radioInput({ onRadioIpChange, simpleIpValue, fieldKey }) {
  return (
    <RadioGroup
      name={fieldKey}
      selectedValue={simpleIpValue}
      className="row radio-fix"
      onChange={onRadioIpChange}
    >
      <Label className="col-6 quick-fact-radio">
        <Radio value="true" className="quick_fact_radio" />
        <span /> Yes
      </Label>
      <Label className="col-6 quick-fact-radio">
        <Radio value="false" className="quick_fact_radio" />
        <span /> No
      </Label>
    </RadioGroup>
  );
}

function uploadInput({
  onSimpleIpChange,
  simpleIpValue,
  fieldKey,
  placeholder,
  openLightbox,
}) {
  let fileInput = React.createRef();

  function onChange() {
    const value = fileInput.current.files[0];
    onSimpleIpChange({
      target: {
        name: fieldKey,
        value,
      },
    });
  }

  function handleClick(e) {
    e.stopPropagation();
    e.preventDefault();
    if (fileInput.current.files[0]) {
      const file = fileInput.current.files[0];
      const reader = new FileReader();

      //starts the reading process of the file
      reader.readAsDataURL(file);

      reader.onloadend = () => {
        openLightbox({ images: [reader.result] });
      };
    } else {
      openLightbox({ images: [`${config.RESOURCE_URL}/${simpleIpValue}`] });
    }
  }

  return (
    <Fragment>
      <input
        style={{ display: 'none' }}
        type="file"
        name={fieldKey}
        placeholder={placeholder}
        onChange={onChange}
        ref={fileInput}
        accept="image/*"
      />
      {simpleIpValue ? (
        <Fragment>
          <p onClick={handleClick}>Click To Open</p>
          <LightboxContainer />
        </Fragment>
      ) : null}
      <Button
        color="primary"
        className={'changeElevationProfile'}
        onClick={() => fileInput.current.click()}
      >
        {simpleIpValue ? 'Change Image' : 'Add Image'}
      </Button>
    </Fragment>
  );
}

export function TerrainInfoComp({
  fieldKey,
  title,
  subtitle,
  simpleIpValue,
  specialIpValue,
  onSimpleIpChange,
  onSpecialIpChange,
  onRadioIpChange,
  uploadUrl,
  openLightbox,
}) {
  const terrainInfoValue = {
    difficulty_level: () =>
      selectInput({
        onSimpleIpChange,
        simpleIpValue,
        fieldKey,
      }),
    highest_altitude: () =>
      simpleInput({
        onSimpleIpChange,
        simpleIpValue,
        placeholder: 'How up?',
        fieldKey,
      }),
    total_length: () =>
      simpleInput({
        onSimpleIpChange,
        simpleIpValue,
        placeholder: 'How long?',
        fieldKey,
      }),
    start_location: () =>
      simpleInput({
        onSimpleIpChange,
        simpleIpValue,
        placeholder: 'Start from?',
        fieldKey,
      }),
    finish_location: () =>
      simpleInput({ onSimpleIpChange, simpleIpValue, placeholder: 'Finish at?', fieldKey }),
    permits: () =>
      simpleInput({
        onSimpleIpChange,
        simpleIpValue,
        placeholder: 'Start from?',
        fieldKey,
      }),
    best_seasons: () =>
      simpleInput({
        onSimpleIpChange,
        simpleIpValue,
        placeholder: 'Start from?',
        fieldKey,
      }),
    elevation_profile: () =>
      uploadInput({
        onSimpleIpChange,
        simpleIpValue,
        placeholder: 'Upload elevation profile...',
        fieldKey,
        openLightbox,
      }),
    total_climb: () =>
      simpleInput({
        onSimpleIpChange,
        simpleIpValue,
        placeholder: 'Permits you require.',
        fieldKey,
      }),
    average_walking_hrs: () =>
      simpleInput({
        onSimpleIpChange,
        simpleIpValue,
        placeholder: 'Best season to trek this.',
        fieldKey,
      }),
    has_domestic_air_travel: () => radioInput({ onRadioIpChange, simpleIpValue, fieldKey }),
  };

  return (
    <li className="open-edit">
      <div className="label">
        {title}
        {subtitle ? ` (${subtitle}) ` : null}
      </div>
      {terrainInfoValue[fieldKey]()}
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/TerrainInfo/Helpers.js